<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->
<!-- ============================================================== -->
<!-- Start Page Content here -->
<!-- ============================================================== -->
@if (!loading && security.permitted('corporation setup', 'corporate list', 'view')) {
  <div class="content-page">
    <div class="content p-1">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="page-title-box">
              <div class="page-title-right">
                <ol class="breadcrumb m-0">
                  <li class="breadcrumb-item"><a href="javascript: void(0);">Settings</a></li>
                  <li class="breadcrumb-item active">Company Setup</li>
                </ol>
              </div>
              <h4 class="page-title" title="Manage company settings">{{
              words[language]['companySetup']}}</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="card">
              <div class="card-header h4">Corporate Information</div>
              <div class="card-body">
                <ul class="list-unstyled">
                  <li><a href="#" (click)="editCorp($event, corporation.id)"
                    class="link-primary">{{corporation.name}} @if (corporation.dbaName) {
                    <span>dba {{corporation.dbaName}}</span>
                  }</a></li>
                  <li>Dealer Number: {{corporation.dealerNumber}}</li>
                  <li>@if (corporation.contact && corporation.contact.contactAddresses && corporation.contact.contactAddresses.length > 0) {
                    <span
                    >{{corporation.contact.contactAddresses[0].address}} {{corporation.contact.contactAddresses[0].city}}, {{corporation.contact.contactAddresses[0].state}} {{corporation.contact.contactAddresses[0].zipCode}}</span>
                  }
                </li>
                <li>@if (corporation.contact && corporation.contact.contactCommunications && corporation.contact.contactCommunications.length > 0) {
                  <span
                  >{{corporation.contact.contactCommunications[0].value | phone}}</span>
                }</li>
              </ul>
              <div class="card d-block shadow-none">
                @if (corporation.corporateLogoURL) {
                  <img class="card-img-top" [src]="corporation.corporateLogoURL"
                    >
                }
                <div class="card-body">
                </div> <!-- end card-body-->
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="d-flex justify-content-start align-items-center">
            <h5>Dealerships</h5>
            <a href="#" class="link-primary" (click)="createDealership($event)"
              title="Add a dealership under corporation {{corporation.name}}"><span class="uil-plus"></span>Add
            Dealership</a>
          </div>
          <div class="corp-list">
            @for (dealership of corporation.dealerships; track dealership; let i = $index) {
              <div class="card">
                <div class="card-header">
                  <a class="btn btn-light collapse-toggle" data-toggle="collapse"
                    href="#contract-content-collapse-{{i}}" aria-expanded="true"
                    aria-controls="contract-content-collapse">
                    <span class="collapse-icon"></span>
                  </a>
                  {{dealership.contact.companyName}} Dealership Information
                  @if (dealership.active=='Active' && security.permitted('corporation setup', 'dealership detail', 'delete')) {
                    <button (click)="checkDealershipRelationships(dealership.id)"
                      class="btn btn-sm btn-link float-right" title="Delete">
                      <span class="dripicons-trash text-danger"></span>
                    </button>
                  }
                  @if (dealership.active=='Disabled') {
                    <button class="btn btn-sm btn-link float-right"
                      title="Restore" (click)="setDealershipId(dealership.id)"
                      data-target="#activateDealershipModal" data-toggle="modal">
                      <span class="uil-redo text-primary"></span>
                    </button>
                  }
                </div>
                <div class="card-body collapse show" id="contract-content-collapse-{{i}}">
                  <ul class="list-unstyled">
                    <li><a href="#" (click)="editDealer($event, dealership.id)"
                      class="link-primary">{{dealership.contact.companyName}}@if (dealership.dbaName) {
                      <span>dba {{dealership.dbaName}}</span>
                    }</a></li>
                    <li>Dealer Number: {{dealership.dealerNumber}}</li>
                    <li>@if (dealership.contact.contactAddresses.length>0) {
                      <span
                      >{{dealership.contact.contactAddresses[0].address}} {{dealership.contact.contactAddresses[0].city}}, {{dealership.contact.contactAddresses[0].state}} {{dealership.contact.contactAddresses[0].zipCode}}</span>
                    }
                  </li>
                  <li>@if (dealership.contact.contactCommunications ? dealership.contact.contactCommunications.length>0 ? dealership.contact.contactCommunications : null : null) {
                    <span
                      >{{dealership.contact.contactCommunications[0].value
                    | phone}}</span>
                  }</li>
                </ul>
                <div class="d-flex justify-content-start align-items-center">
                  <h5>Lots</h5>
                  @if (security.permitted('corporation setup', 'lot detail', 'add')) {
                    <a href="#" (click)="createLot($event, dealership.id)"
                      title="Add a lot under dealership {{dealership.contact.companyName}}"
                      class="link-primary"> <span class="uil-plus"></span>Add Lot to
                    {{dealership.contact.companyName}}</a>
                  }
                </div>
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>DBA</th>
                      <th>Dealer Number</th>
                      <th>Address</th>
                      <th>Phone Number</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (lot of dealership.lots; track lot) {
                      <tr>
                        <td><a href="#" (click)="editLot($event, lot.id)"
                        class="link-primary">{{lot.contact.companyName}}</a></td>
                        <td>{{lot.dbaName}}</td>
                        <td>{{lot.dealerNumber}}</td>
                        <td>@if (lot.contact && lot.contact.contactAddresses && lot.contact.contactAddresses.length > 0) {
                          <span
                          >{{lot.contact.contactAddresses[0].address}} {{lot.contact.contactAddresses[0].city}}, {{lot.contact.contactAddresses[0].state}} {{lot.contact.contactAddresses[0].zipCode}}</span>
                        }
                      </td>
                      <td>@if (lot.contact.contactCommunications ? lot.contact.contactCommunications.length>0 ? lot.contact.contactCommunications : null : null) {
                        <span
                          >{{lot.contact.contactCommunications[0].value
                        | phone}}</span>
                      }</td>
                      <td class="text-right">
                        @if (lot.active == 'Active' && security.permitted('corporation setup', 'lot detail', 'delete')) {
                          <button class="btn btn-sm btn-link"
                            title="Delete" (click)="checkLotRelationships(lot.id)">
                            <span class="dripicons-trash text-danger"></span>
                          </button>
                        }
                        @if (lot.active == 'Disabled' && security.permitted('corporation setup', 'lot detail', 'delete')) {
                          <button class="btn btn-sm btn-link"
                            title="Restore" (click)="setLotId(lot.id)"
                            data-target="#activateLotModal" data-toggle="modal">
                            <span class="uil-redo text-primary"></span>
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
</div>
</div>
}

<!-- loading -->
@if (loading ) {
  <div class="content-page bg-gray d-flex justify-content-center align-items-center">
    <div class="spinner-grow avatar-lg text-secondary" role="status"></div>
  </div>
}

<!-- deactivate -->
<button class="d-none" data-target="#deactivateLotModal" data-toggle="modal" id="btn-deactivate-lot-modal"></button>
<!-- deactivate modal -->
<div class="modal fade" id="deactivateLotModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
 >
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger display-3"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'deactivate' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deactivateInfo' ] }}</span>
        <button class="btn btn-danger mt-2" (click)="deactivateLot()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        {{ words[language][ 'continue' ] }}</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-deactivate">{{
        words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- deactivate -->
<button class="d-none" data-target="#deactivateDealershipModal" data-toggle="modal"
id="btn-deactivate-dealership-modal"></button>
<!-- deactivate modal -->
<div class="modal fade" id="deactivateDealershipModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
 >
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger display-3"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'deactivate' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deactivateInfo' ] }}</span>
        <button class="btn btn-danger mt-2" (click)="deactivateDealership()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        {{ words[language][ 'continue' ] }}</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
          id="btn-close-modal-deactivate-dealership">{{
        words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- delete -->
<!-- delete modal -->
<button class="d-none" data-target="#deleteDealershipModal" data-toggle="modal"
id="btn-deleteDealership-modal"></button>
<div class="modal fade" id="deleteDealershipModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
 >
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger display-3"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteQuest' ] }}
        {{itemSelected.entity}}?</span>
        <button class="btn btn-danger mt-2" (click)="deleteDealership()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        {{ words[language][ 'continue' ] }}</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
          id="btn-close-modal-deleteDealership">{{
        words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- delete -->
<!-- delete modal -->
<button class="d-none" data-target="#deleteLotModal" data-toggle="modal" id="btn-deleteLot-modal"></button>
<div class="modal fade" id="deleteLotModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
 >
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger display-3"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteQuest' ] }}
        {{itemSelected.entity}}?</span>
        <button class="btn btn-danger mt-2" (click)="deleteLot()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        {{ words[language][ 'continue' ] }}</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-deleteLot">{{
        words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
<!-- delete -->
<button class="d-none" data-target="#activateLotModal" data-toggle="modal" id="btn-active-modal-lot"></button>
<!-- delete modal -->
<div class="modal fade" id="activateLotModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
 >
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-warning text-warning display-3"></span>
        <h4 class="text-warning w-100 text-center">{{ words[language][ 'reactivate' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'reactivateQuest' ] }}
        {{itemSelected.entity}} ?</span>
        <button class="btn btn-warning mt-2" (click)="activateLot()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        {{ words[language][ 'continue' ] }}</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-activate-lot">{{
        words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
<!-- delete -->
<button class="d-none" data-target="#activateDealershipModal" data-toggle="modal"
id="btn-active-modal-dealership"></button>
<!-- delete modal -->
<div class="modal fade" id="activateDealershipModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
 >
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-warning text-warning display-3"></span>
        <h4 class="text-warning w-100 text-center">{{ words[language][ 'reactivate' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'reactivateQuest' ] }}
        {{itemSelected.entity}} ?</span>
        <button class="btn btn-warning mt-2" (click)="activateDealership()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        {{ words[language][ 'continue' ] }}</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
          id="btn-close-modal-activate-dealership">{{
        words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->